module.exports = __webpack_public_path__ + "img/productOut.49fef94d.png";